// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__xoXNn","leftTop":"index_leftTop___yE6c","leftBottom":"index_leftBottom__E_2DB","rightTop":"index_rightTop__SKbyD","rightBottom":"index_rightBottom__jbYoj"};